<template>
  <v-data-table
    show-expand
    :server-items-length="itemsLength"
    :headers="headersPromo"
    :items="gridItems"
    @update:options="optionsUpdated($event)"
    disable-sort
  >
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" class="pa-4 blue-grey lighten-5">
        <v-row no-gutters>
          <v-col cols="12"><span class="text-body-1">Правила:</span></v-col>
        </v-row>
        <v-row v-for="(rule, index) in item.rules" no-gutters class="body-2">
          <v-col cols="1" class="text-body-1">{{ index + 1 }})</v-col>
          <v-col cols="11" class="pb-2">
            <v-row no-gutters v-for="(field, key) in prepareRule(rule)">
              <v-col cols="6">
                {{ rulesAliases[key] }}:
              </v-col>
              <v-col cols="6">
                {{ field }}
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn color="secondary" @click="deactivatePromo(item.id)">Отключить</v-btn>
          </v-col>
        </v-row>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import ServerGrid from "@/components/common/ServerGrid";
import { deactivatePromo, getPromos } from "@/api/promos";
import { rulesAliases } from "@/utils/rulesAliases";
import dateFormat from "@/utils/formatDate";

const dateMask = "dd/mm/yyyy";

export default {
  name: "promos",
  data() {
    return {
      firstLoading: true,
      headersPromo: [
        {
          value: "name",
          text: "Название акции",
        },
        {
          value: "description",
          text: "Описание",
        },
        { value: "data-table-expand" },
        { value: "actions" },
      ],
      gridItems: [],
      rulesAliases: rulesAliases,
    };
  },
  methods: {
    async deactivatePromo(id) {
      console.log("deactivating");
      await deactivatePromo(id);
      await this.getPromos({page: 1, pageSize: 100});
    },
    async getPromos(data) {
      this.gridItems = await getPromos(data);
    },
    prepareRule(rule) {
      const _rule = {};
      for (let key in rule) {
        if (rule.hasOwnProperty(key)) {
          if (key === "tp" || key === "reward_type") _rule[key] = rulesAliases[rule[key]];
          if (key === "date") _rule[key] = "От " + dateFormat(rule[key].from, dateMask) +
            ((rule[key].to) ? (" до " + dateFormat(rule[key].to, dateMask)) : "");
          if ((key === "ost_q" || key === "shar_coefficient") && rule[key]) _rule[key] = rule[key] * 100 + "%";
          if (key === "fix_cost" && rule[key]) _rule[key] = rule[key] + "р.";
          if ((key === "clients" || key === "clients_ever") && rule[key].from && rule[key].to) _rule[key] =
            "От " + rule[key].from + " до " + rule[key].to;
        }
      }
      return _rule;
    },
    optionsUpdated(options) {
      if (!this.firstLoading) this.getPromos({
        page: options.page,
        pageSize: options.itemsPerPage,
      });
    },
  },
  async mounted() {
    await this.getPromos({page: 1, pageSize: 10});
    this.firstLoading = false;
  },
  computed: {
    itemsLength() {
      return this.gridItems.length;
    },
  },
  components: {
    ServerGrid,
  },

};
</script>

<style scoped lang="scss">

</style>
